"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PopoverViewportCssVars = void 0;
let PopoverViewportCssVars = exports.PopoverViewportCssVars = /*#__PURE__*/function (PopoverViewportCssVars) {
  /**
   * The width of the parent popup.
   * This variable is placed on the 'previous' container and stores the width of the popup when the previous content was rendered.
   * It can be used to freeze the dimensions of the popup when animating between different content.
   */
  PopoverViewportCssVars["popupWidth"] = "--popup-width";
  /**
   * The height of the parent popup.
   * This variable is placed on the 'previous' container and stores the height of the popup when the previous content was rendered.
   * It can be used to freeze the dimensions of the popup when animating between different content.
   */
  PopoverViewportCssVars["popupHeight"] = "--popup-height";
  return PopoverViewportCssVars;
}({});